import PropTypes from 'prop-types'

import {Text} from '@chakra-ui/react'

const SectionSubtitle = ({text, ...props}) => {
  return (
    <Text textStyle="body-small" maxW={{base: '100%', md: '80%'}} {...props}>
      {text}
    </Text>
  )
}

SectionSubtitle.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

export default SectionSubtitle
